import store from '@/store';
import { NavigationGuardNext, Route } from 'vue-router';
import { RouteName } from '@/router/types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function profileGuard(to: Route, from: Route, next: NavigationGuardNext): boolean {
  if (!store.getters['tenant/isProfileAvailable']) {
    next({ name: RouteName.Community });
  } else {
    next();
  }
  return true;
}
